(() => {
  const gate = document.querySelector('[data-age-gate]');
  if (!gate || localStorage.getItem('vantage-age-confirmed') === 'yes') { if (gate) gate.hidden = true; return; }
  document.body.classList.add('gate-open');
  gate.querySelector('[data-age-yes]').addEventListener('click', () => { localStorage.setItem('vantage-age-confirmed','yes'); gate.hidden = true; document.body.classList.remove('gate-open'); });
  gate.querySelector('[data-age-no]').addEventListener('click', () => { window.location.href = 'https://www.google.com'; });
})();
